import { ActionReducerMapBuilder, createAction } from '@reduxjs/toolkit';
import {
  formatGroupedTripsReportItem,
  formatTripsReportItem,
  formatTripsReportTotal,
} from '../utils/helpers';
import {
  TransportGroupedTripsReportItemDTO,
  TransportTripsReportItemDTO,
  TripsReportSlice,
} from '../types';
import { ReportsSlice, ReportType } from '../../../types';
import { getTripsReport } from '../services/tripsReportService';

export const tripsInitialState: TripsReportSlice = {
  isFailed: false,
  isLoading: false,
  transports: {},
};

export const resetState = createAction('trips/resetState');

export const tripsReducers = (
  builder: ActionReducerMapBuilder<ReportsSlice<TripsReportSlice>>,
) => {
  builder.addCase(getTripsReport.pending, (state) => {
    state[ReportType.TRIPS].isLoading = true;
  });

  builder.addCase(getTripsReport.fulfilled, (state, action) => {
    state[ReportType.TRIPS].isLoading = false;
    const { groupByDays } = action.meta.arg;

    Object.entries(action.payload.transports).forEach(([key, value]) => {
      state[ReportType.TRIPS].transports[Number(key)] = {
        total: formatTripsReportTotal(value.total, value.items, groupByDays),
        items: groupByDays
          ? formatGroupedTripsReportItem(
              value.items as TransportGroupedTripsReportItemDTO[],
            )
          : formatTripsReportItem(value.items as TransportTripsReportItemDTO[]),
      };
    });
  });

  builder.addCase(getTripsReport.rejected, (state) => {
    state[ReportType.TRIPS].isLoading = false;
    state[ReportType.TRIPS].isFailed = true;
  });

  builder.addCase(resetState, (state) => {
    state[ReportType.TRIPS] = tripsInitialState;
  });
};
